const errorLogger = async (error) => {
  // const errorlog = await errorLogService.addErrorLog({ log: JSON.stringify(error) });
  // kayanya ini mending untuk local logger aja pengganti console.log, yang ke DB biar langsung dari BE aja
  if (['DEVELOPMENT', 'STAGING'].includes(process.env.REACT_APP_STAGE)) console.log(error);
};

export default errorLogger;
